module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-1-33d353f0ec8683e6fa414bdd97ce1192.png";